import { Navigate } from "react-router-dom";

const EmployeeDashboardIndex = () => {
  return <Navigate to="/dashboard/employee/overview" replace />;
};

export default EmployeeDashboardIndex;
